import { View } from '@react-pdf/renderer';
import { pdfStyles } from '../../..';
import { InvoiceInterface } from '../../../../interfaces/invoice.interface';
import { ProductInOrder } from '../../../../interfaces/product.interface';
import { PdfProductsList } from './PdfProductsList';
import { PdfProductsTable } from './PdfProductsTable';

interface Props {
  doc: InvoiceInterface;
  products: ProductInOrder[];
  docHasVatExceptionCategory?: boolean;
}

export const PdfProductsSection = ({ doc, products, docHasVatExceptionCategory = false }: Props) => {
  return (
    <View style={pdfStyles.column}>
      <View>
        <PdfProductsTable doc={doc} />
      </View>
      <View>
        <PdfProductsList doc={doc} products={products} docHasVatExceptionCategory={docHasVatExceptionCategory} />
      </View>
    </View>
  );
};
